<template>
  <app-table-row>
    <app-table-cell>{{ loan.name }}</app-table-cell>
    <app-table-cell>{{ loan.service_number }}</app-table-cell>
    <app-table-cell><router-link :to="{ name: 'ViewCourse', params: { courseId: course.id, instanceId: instance.id }} ">{{ course.name }} {{ instance.name }}</router-link></app-table-cell>
    <app-table-cell>
      <app-date-time :date-str="loan.start_date" v-if="loan.start_date" />
      <span v-else>Awaiting Collection</span>
      <small class="d-block text-muted">{{ signedOutBy }}</small>
    </app-table-cell>
    <app-table-cell>
      <app-date-time :date-str="loan.end_date" v-if="loan.end_date" />
      <small class="d-block text-muted">{{ returnedBy }}</small>
    </app-table-cell>
    <app-table-cell>
      <device-loan-notes class="btn-sm" :device="device" :loan="loan">Notes</device-loan-notes>
    </app-table-cell>
    <app-table-cell>
      <img src="@/assets/ipad-icon.svg" width="24" class="d-block mx-auto" alt="Device icon" title="Device returned damaged or was lost" v-if="loan.device_damaged">
      <img src="@/assets/charger-icon.svg" width="24" class="d-block mx-auto" alt="Accessories icon" title="Accessories lost or missing" v-if="loan.accessories_missing">
    </app-table-cell>
  </app-table-row>
</template>

<script>
import DeviceLoanNotes from '@/components/DeviceLoanNotes/DeviceLoanNotes'

export default {
  name: 'DeviceLoanHistoryRow',
  components: {
    DeviceLoanNotes
  },
  props: {
    loan: {
      type: Object,
      required: true
    }
  },
  computed: {
    instance() {
      return this.loan.instance
    },
    course() {
      return this.instance.course
    },
    signedOutBy() {
      return this.loan.signed_out_by?.name
    },
    returnedBy() {
      return this.loan.returned_by?.name
    }
  }
}
</script>
